import { Component, Inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-fields-data-select',
    templateUrl: './fields-data-select.component.html',
    styleUrls: ['./fields-data-select.component.scss'],
    standalone: false
})
export class  FieldsDataSelectComponent implements OnInit {

  readonly fieldsNotShow = ['BODY','STATUS','REQUESTBODY','RESPONSEBODY','RECMODIFIEDON','RECMODIFIEDBY','ACTIVE','CODECONTRACT','IDCONF','KIT','MESSAGE']

  constructor( @Inject(NZ_MODAL_DATA) public data, public dialogRef:NzModalRef<any>) { }

  ngOnInit(): void {
  }

  select(cat){
    this.dialogRef.close(cat.value);
  }

  canShow(cat){
    if ( this.fieldsNotShow.indexOf(cat.key) == -1 ){
      if ( cat.value != null){
        return true;
      }else{
        return false;
      }
      
    }else{
      return false;
    }
  }

}
